import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    label {
      cursor: pointer;
      transition: opacity 300ms;

      &:hover {
        opacity: 0.7;
      }

      img,
      div {
        height: 200px;
        width: 200px;
        object-fit: contain;

        padding: 10px;

        background: ${theme.colors.secondary};
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        border-radius: 45px;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        svg {
          color: #dddddd;
          width: 40px;
          height: 40px;
        }

        strong {
          color: #dddddd;
          font-size: 16px;
        }
      }

      input {
        display: none;
      }
    }
  `}
`
